import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

Container.Header = styled.div`
  background: ${(props) => props.theme.background};
  box-shadow: ${(props) => `0px 3px 6px ${props.theme.boxShadow}`};
  border-radius: 10px;
  /* height: 100%; */
  /* min-height: 58px; */
  padding: 5px;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: stretch;
`;

Container.Header.BtnBack = styled.button`
  background: none;
  border-radius: 10px;
  border: none;
  /* margin-left: 10px; */
  height: 30px;
  width: 30px;
  color: ${(props) => props.theme.color};
  transition: all 1s;

  :hover {
    /* background: ${darken(0.05, '#fff')}; */
    background: ${darken(0.05, 'rgba(44, 64, 90, 0.05)')};
  }
`;

Container.Header.DownloadPdf = styled.a`
  background: none;
  border: 0;
  border-radius: 10px;
  color: ${(props) => props.theme.color};
  height: 30px;
  width: 30px;
  transition: all 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
`;

Container.WrapperBtns = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 5px;
`;

Container.Header.BtnFavorite = styled.button`
  background: none;
  border: 0;
  border-radius: 5px;
  color: #2c405a;
  height: 40px;
  width: 40px;
`;

export const WrapperTitleInfo = styled.div`
  display: flex;
  flex-direction: column;
  /* flex: 1; */
  padding-right: 25px;
  > span {
    color: ${(props) => props.theme.color};
  }
`;

export const WrapperShared = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #e5e7eb; */
  background: ${(props) => props.theme.buttonBackground};
  /* color: #3b82f6; */
  color: ${(props) => props.theme.colorSharedButton};
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
`;

export const WrapperSubtitles = styled.div`
  display: flex;
  /* flex: 1; */
  flex-direction: row;
  /* padding: 0 10px; */
`;

export const WrapperTittleInfoSubtitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* flex: 1; */
  flex-direction: row;
  /* padding: 4px; */
`;

Container.Header.Title = styled.h1`
  width: auto;
  font-size: 14px;
`;

Container.Header.Subtitle = styled.span`
  font-size: 12px;
  padding-top: 2px;

  + span {
    padding-left: 5px;
  }
`;

Container.Header.Search = styled.div`
  /* padding: 2px 10px; */
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  position: relative;
`;

Main.Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
`;

Main.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 5px 0;
  overflow-y: auto;

  border-radius: 10px;
`;

export const BtnTreeView = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #e5e7eb; */
  background: ${(props) => props.theme.buttonBackground};
  /* color: #3b82f6; */
  color: ${(props) => props.theme.color};
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  /* position: relative; */
  /* width: 35%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: ${(props) => props.theme.cardBackground};
  color: ${(props) => props.theme.color};
  border-radius: 10px;
  box-shadow: ${(props) => `0px 3px 6px ${props.theme.boxShadow}`}; */
  /* z-index: 5; */
`;

const Menu = styled.div`
  display: flex;
  box-shadow: ${(props) => `0px 3px 6px ${props.theme.boxShadow}`};

  background: ${(props) => props.theme.background};
  border-radius: 10px;
  height: calc(100vh - 180px);
  max-width: 100%
  margin-right: 20px;
  z-index: 1;
`;

Menu.BtnCollapse = styled.button`
  background: none;
  border: 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #a7a7a7;
  width: 18px;
  transform: background 1s;

  ${(props) =>
    props.collapse &&
    css`
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    `}

  :hover {
    background: #cad5f8;
    color: #fff;
  }
`;

Menu.Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  visibility: visible;

  /* oculta/exibe menu lateral */
  ${(props) =>
    props.hidden &&
    css`
      width: 0;
      padding: 0;
      visibility: hidden;
    `}
`;

Menu.Content.Filter = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  padding: 0 5px;

  > span {
    display: flex;
    align-items: center;
    border: 1px solid #cbd0d8;
    color: #444;
    height: 22px;
    border-radius: 5px;
    padding-left: 5px;
    margin: 2px 0;

    & + span {
      margin-left: 5px;
    }

    > button {
      height: 22px;
      width: 22px;
      color: #444;
      margin-left: 5px;
      background: none;
      border: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      transition: background 1s;

      :hover {
        border: 1px solid #cad5f8;
        background: #cad5f8;
        color: #fff;
      }
    }
  }
`;

Menu.Content.TreeView = styled.div`
  flex: 1;
  overflow: auto;

  padding: 5px 0 5px 2px;

  ::-webkit-scrollbar {
    display: none;
  }
`;

Menu.Content.File = styled.div`
  margin-top: 20px;
  border-top: 1px solid #0000000d;
  padding: 20px 0;

  > h4 {
    font-size: 16px;
  }

  > ul {
    padding: 15px 0;

    > li {
      padding: 2px 0;

      > a {
        font-size: 14px;
        color: #2c405a;
        transform: color 1s;

        :hover {
          color: ${darken(0.05, '#2c405a')};
        }
      }
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  background: ${(props) => props.theme.background};

  box-shadow: ${(props) => `0px 3px 6px ${props.theme.boxShadow}`};
  border-radius: 10px;
`;

Content.BtnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  margin: 5px 0;
`;

Content.ToolBar = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  padding: 5px;
`;

Content.ToolBar.Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 13px;
  padding: 5px;

  > h3 {
    font-size: 13px;
    padding: 5px 0;
  }

  > a {
    padding: 5px 0;
    font-size: 12px;
    transform: color 1s;
    color: ${(props) => props.theme.color};

    :hover {
      color: ${darken(0.05, '#888888')};
      /* text-decoration: underline; */
    }
  }
`;

export const ContentToolBarHeaderButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #e5e7eb; */
  background: ${(props) => props.theme.buttonBackground};
  /* color: #3b82f6; */
  color: ${(props) => props.theme.color};
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  /* width: 35%;
  height: 30px;
  border: none;
  background: ${(props) => props.theme.cardBackground};
  color: ${(props) => props.theme.color};
  border-radius: 10px;
  box-shadow: ${(props) => `0px 3px 6px ${props.theme.boxShadow}`}; */
`;

export const BtnShare = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute; */
  bottom: 0;
  right: 0;
  margin: 0 15px 15px 0;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  /* background-color: #2c405a; */
  background-color: #e5e7eb;
  /* color: #fff; */
  color: #3b82f6;
`;

Content.ToolBar.DrawControl = styled.div`
  display: flex;
  justify-content: flex-end;

  color: ${(props) => props.theme.color};

  > button,
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: 0; */
    border-radius: 10px;

    height: 32px;
    width: 32px;

    background: none;
    border: 0;
    color: ${(props) => props.theme.color};
    transition: background 1s;

    + button {
      margin-left: 2px;
    }

    + span {
      width: none;
      margin-left: 5px;
      padding: 0 8px;
      white-space: nowrap;
    }

    :hover {
      background: ${darken(0.05, 'rgba(44, 64, 90, 0.05)')};
    }
  }

  /** separação entre ferramentas de navegação de páginas e redimensionamneto da imagem */
  button:nth-of-type(2) {
    margin-right: 5px;
  }
`;

export const BtnFilter = styled.button`
  padding: 0 8px;
  height: 40px;
  margin: auto;
  background-color: #2c405a;
  color: #fff;
  border-radius: 0 5px 5px 0;
  border: none;
`;

export const WrapperFilterContent = styled.div`
  flex: 1;
  color: #888888;
  font-size: 13px;

  > div {
    display: flex;
    align-items: center;
    padding-left: 5px;

    > h5 {
      font-size: 14px;
      display: inline;
      padding-right: 3px;
    }

    > span {
      padding: 5px 0 5px 0;
      font-size: 14px;
      padding-right: 3px;
    }

    > button {
      margin-left: 5px;
      background-color: #fecaca;
      align-content: center;
      border-radius: 5px;
      width: 25px;
      height: 25px;
      border: none;
      color: #dc2626;
      transition: 0.5s;

      &:hover {
        transition: 0.5s;
        background-color: #fca5a5;
        color: #b91c1c;
      }
    }
  }
`;

export { Menu };
